export default "__VITE_ASSET__B1IXIl5Y__"